import { galleryPath } from "../routes";

/**
 * Maps a push notification's custom `data` map onto a webapp path, for
 * notifications that arrive while the app is in the foreground.
 *
 * This mirrors `resolveDeepLink` in `public/firebase-messaging-sw.js`, which
 * does the same job for background (clicked) notifications. The service worker
 * is plain JS served outside the bundle and cannot import this module, so the
 * two must be kept in sync by hand — add a case to both.
 */
export function resolveNotificationPath(notification: {
  type?: string;
  eventId?: string;
}): string | null {
  switch (notification.type) {
    case "gallery_photo_added":
      return notification.eventId ? galleryPath(notification.eventId) : null;
    default:
      return null;
  }
}
